import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const PAPI = `${BASE}/api`;

const papi = axios.create({ baseURL: PAPI });

export function saveProAuth(data) {
  if (data?.token) localStorage.setItem("lx_pro_token", data.token);
  if (data?.refresh_token) localStorage.setItem("lx_pro_refresh", data.refresh_token);
}
export function clearProAuth() {
  localStorage.removeItem("lx_pro_token");
  localStorage.removeItem("lx_pro_refresh");
}

papi.interceptors.request.use((config) => {
  const token = localStorage.getItem("lx_pro_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
async function tryRefresh() {
  const rt = localStorage.getItem("lx_pro_refresh");
  if (!rt) return null;
  if (!refreshing) {
    refreshing = axios
      .post(`${PAPI}/verify/pro/refresh`, { refresh_token: rt })
      .then((r) => { saveProAuth(r.data); return r.data.token; })
      .catch(() => { clearProAuth(); return null; })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

papi.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    const isAuthCall = url.includes("/pro/refresh") || url.includes("/pro/login");
    if (err.response?.status === 401 && !cfg._retry && !isAuthCall) {
      cfg._retry = true;
      const nt = await tryRefresh();
      if (nt) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = `Bearer ${nt}`;
        return papi(cfg);
      }
      clearProAuth();
    }
    return Promise.reject(err);
  }
);

export default papi;
